/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-b011b919.mjs';
import { defineComponent, ref, computed, createVNode, h, onBeforeMount, onMounted } from 'vue';
import { InfoCircleFilledIcon, CheckCircleFilledIcon, ErrorCircleFilledIcon, HelpCircleFilledIcon, CloseIcon } from 'tdesign-icons-vue-next';
import { Loading } from '../loading/index.mjs';
import { THEME_LIST } from './const.mjs';
import props from './props.mjs';
import { usePrefixClass } from '../hooks/useConfig.mjs';
import { useGlobalIcon } from '../hooks/useGlobalIcon.mjs';
import { fadeOut, fadeIn } from './animation.mjs';
import { useTNodeJSX, useContent } from '../hooks/tnode.mjs';
import { i as isFunction_1 } from '../_chunks/dep-8d19eb1a.mjs';
import '../_chunks/dep-ae1abe1d.mjs';
import '../loading/directive.mjs';
import '../loading/plugin.mjs';
import '../loading/loading.mjs';
import '../_chunks/dep-fc63c737.mjs';
import '../_chunks/dep-2a2a0e63.mjs';
import '../loading/icon/gradient.mjs';
import '../_common/js/loading/circle-adapter.mjs';
import '../_common/js/utils/set-style.mjs';
import '../_common/js/utils/helper.mjs';
import '../_chunks/dep-56ceb7ce.mjs';
import '../_chunks/dep-c3626417.mjs';
import '../_chunks/dep-7f2f03b4.mjs';
import '../_chunks/dep-eba62589.mjs';
import '../_chunks/dep-7d9e11c8.mjs';
import '../_chunks/dep-b9567f6a.mjs';
import '../_chunks/dep-654b4b01.mjs';
import '../_chunks/dep-a6022780.mjs';
import '../_chunks/dep-e00db566.mjs';
import '../_chunks/dep-fdde96c5.mjs';
import '../_chunks/dep-961339ce.mjs';
import '../utils/dom.mjs';
import '../utils/easing.mjs';
import '../utils/render-tnode.mjs';
import '../_chunks/dep-ff1c0573.mjs';
import '../_chunks/dep-42be3824.mjs';
import '../_chunks/dep-a11a63ea.mjs';
import '../_chunks/dep-750294df.mjs';
import '../_chunks/dep-ad1accf9.mjs';
import '../_chunks/dep-a255de71.mjs';
import '../_chunks/dep-ebe8bc2f.mjs';
import '../_chunks/dep-16e2f1a5.mjs';
import '../_chunks/dep-ebfafd52.mjs';
import '../_chunks/dep-3e3494dc.mjs';
import '../_chunks/dep-f50ac97c.mjs';
import '../_chunks/dep-94585de3.mjs';
import '../_chunks/dep-06221fe2.mjs';
import '../_chunks/dep-d7053a2c.mjs';
import '../_chunks/dep-f3e3393e.mjs';
import '../_chunks/dep-0fa7026c.mjs';
import '../_chunks/dep-31dc9d09.mjs';
import '../_chunks/dep-b9d74a58.mjs';
import '../loading/props.mjs';
import '../hooks/useTeleport.mjs';
import '../config-provider/useConfig.mjs';
import '../_chunks/dep-adebe2ce.mjs';
import '../_chunks/dep-bd3d75f1.mjs';
import '../_chunks/dep-2b8d75e2.mjs';
import '../_chunks/dep-8f44163a.mjs';
import '../_chunks/dep-cc371884.mjs';
import '../_chunks/dep-1f0070bb.mjs';
import '../_chunks/dep-9d0d32fd.mjs';
import '../_chunks/dep-e05e20e6.mjs';
import '../_chunks/dep-67dfe9c7.mjs';
import '../_chunks/dep-a0bd2e3a.mjs';
import '../_chunks/dep-91208ac3.mjs';
import '../_chunks/dep-1041f7d7.mjs';
import '../_chunks/dep-b32fb318.mjs';
import '../_chunks/dep-9b57842b.mjs';
import '../_common/js/global-config/default-config.mjs';
import '../_common/js/global-config/locale/zh_CN.mjs';
import '../_chunks/dep-99a0abba.mjs';
import '../_chunks/dep-9d5ee0e1.mjs';
import '../config-provider/type.mjs';
import '../utils/withInstall.mjs';
import './style/css.mjs';
import '../loading/type.mjs';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var _Message = defineComponent({
  name: "TMessage",
  props: _objectSpread(_objectSpread({}, props), {}, {
    placement: String
  }),
  setup: function setup(props2, _ref) {
    var slots = _ref.slots,
      expose = _ref.expose;
    var COMPONENT_NAME = usePrefixClass("message");
    var _useGlobalIcon = useGlobalIcon({
        InfoCircleFilledIcon: InfoCircleFilledIcon,
        CheckCircleFilledIcon: CheckCircleFilledIcon,
        ErrorCircleFilledIcon: ErrorCircleFilledIcon,
        HelpCircleFilledIcon: HelpCircleFilledIcon,
        CloseIcon: CloseIcon
      }),
      InfoCircleFilledIcon$1 = _useGlobalIcon.InfoCircleFilledIcon,
      CheckCircleFilledIcon$1 = _useGlobalIcon.CheckCircleFilledIcon,
      ErrorCircleFilledIcon$1 = _useGlobalIcon.ErrorCircleFilledIcon,
      HelpCircleFilledIcon$1 = _useGlobalIcon.HelpCircleFilledIcon,
      CloseIcon$1 = _useGlobalIcon.CloseIcon;
    var classPrefix = usePrefixClass();
    var renderTNode = useTNodeJSX();
    var renderContent = useContent();
    var msgRef = ref(null);
    var timer = ref(null);
    var classes = computed(function () {
      var status = {};
      THEME_LIST.forEach(function (t) {
        return status["".concat(classPrefix.value, "-is-").concat(t)] = props2.theme === t;
      });
      return [COMPONENT_NAME.value, status, _defineProperty({}, "".concat(classPrefix.value, "-is-closable"), props2.closeBtn || slots.closeBtn)];
    });
    var close = function close(e) {
      var _props2$onCloseBtnCli;
      (_props2$onCloseBtnCli = props2.onCloseBtnClick) === null || _props2$onCloseBtnCli === void 0 ? void 0 : _props2$onCloseBtnCli.call(props2, {
        e: e
      });
    };
    var clearTimer = function clearTimer() {
      props2.duration && clearTimeout(timer.value);
    };
    var setTimer = function setTimer() {
      if (!props2.duration) {
        return;
      }
      timer.value = Number(setTimeout(function () {
        clearTimer();
        var msgDom = msgRef.value;
        fadeOut(msgDom, props2.placement, function () {
          var _props2$onDurationEnd;
          (_props2$onDurationEnd = props2.onDurationEnd) === null || _props2$onDurationEnd === void 0 ? void 0 : _props2$onDurationEnd.call(props2);
        });
      }, props2.duration));
    };
    var renderClose = function renderClose() {
      var defaultClose = createVNode(CloseIcon$1, null, null);
      return createVNode("span", {
        "class": "".concat(COMPONENT_NAME.value, "__close"),
        "onClick": close
      }, [renderTNode("closeBtn", defaultClose)]);
    };
    var renderIcon = function renderIcon() {
      if (props2.icon === false) return;
      if (isFunction_1(props2.icon)) return props2.icon(h);
      if (slots.icon) {
        return slots.icon(null);
      }
      var Icon = {
        info: InfoCircleFilledIcon$1,
        success: CheckCircleFilledIcon$1,
        warning: ErrorCircleFilledIcon$1,
        error: ErrorCircleFilledIcon$1,
        question: HelpCircleFilledIcon$1,
        loading: Loading
      }[props2.theme];
      return createVNode(Icon, null, null);
    };
    onBeforeMount(function () {
      props2.duration && setTimer();
    });
    onMounted(function () {
      var msgDom = msgRef.value;
      fadeIn(msgDom, props2.placement);
    });
    expose({
      close: close
    });
    return function () {
      return createVNode("div", {
        "ref": msgRef,
        "class": classes.value,
        "onMouseenter": clearTimer,
        "onMouseleave": setTimer
      }, [renderIcon(), renderContent("content", "default"), renderClose()]);
    };
  }
});

export { _Message as default };
//# sourceMappingURL=message.mjs.map
